function hasText(value) {
  return typeof value === "string" && value.trim().length > 0;
}

export function hasCtaTitle(title) {
  if (!title) return false;
  if (typeof title === "string") return hasText(title);

  function walk(node) {
    if (!node) return false;
    if (typeof node.text === "string" && node.text.trim().length > 0) return true;
    if (Array.isArray(node.children)) return node.children.some(walk);
    return false;
  }

  return walk(title);
}
